let url;
let socketUrl;
let base_url;
let storage_path;

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  url = "http://localhost:8000/api";
  socketUrl = "http://localhost:8000/api";
  base_url = "http://localhost:8000";
  storage_path = "http://localhost:8000/storage/images/item-img/";
} else {
  url = "https://api-ekanban.kelola.dev/api";
  socketUrl = "https://api-ekanban.kelola.dev/api";
  base_url = "https://api-ekanban.kelola.dev";
  storage_path = "https://api-ekanban.kelola.dev/storage/images/item-img/";
  // url = "https://api.ekanban.sankei-dharma.co.id/api";
}



export { url, socketUrl, base_url, storage_path };
